import { GetAaoNaoOptionsResponse, AaoNaoOptions } from 'types/Meteorology/Weather/Area/Status/AAONAO/getAaoNaoOptionsResponse';

const transformGetAaoNaoOptionsResponse = (response: GetAaoNaoOptionsResponse): AaoNaoOptions => ({
  models: response.data.models,
  periods: response.data.periods,
});

export default transformGetAaoNaoOptionsResponse;
